import pick from 'lodash/pick'

/**
 * キャンペーンレポートデータとキャンペーン検索結果をマージする。
 * キャンペーンBPを配列の単位とする。
 */
const mergeCampaignReportData = reportData => {
  const columns = reportData.columns
    .map(c => c.name)
    .filter(c => c !== 'campaign' && c !== 'campaignId')

  return [
    ...reportData.data.map(datum => {
      return {
        id: datum.campaignId,
        name: datum.campaign,
        budgets: datum.budgets,
        ...pick(datum, columns),
      }
    }),
  ]
}

export default mergeCampaignReportData
